import { useNavigate } from "react-router-dom"
import { Button } from "../../ui/button"
import { Card, CardContent } from "../../ui/card"
import { ArrowLeft, Home } from "lucide-react"

const featuresList = [
  { title: "Help When You Need It", description: "Shovel House connects you with neighborhood helpers ready to assist with snow shoveling and lawn mowing. Post a job, and helpers will respond quickly." },
  { title: "Save Money on Services", description: "Set your own price or request volunteer help. Shovel House gives you control over costs, allowing you to save compared to traditional contracts." },
  { title: "Safe Payment Options", description: "Payments are processed securely through Stripe, and you only pay once the job is complete." },
  { title: "No-Contact Service", description: "Enjoy peace of mind with our no-contact service. Helpers use the tools you leave outside or in your shed, and you can monitor their work without needing to interact directly." },
  { title: "Customized Service Requests", description: "Easily create detailed job requests with specific instructions and preferred times. Get matched with helpers who meet your needs." },
  { title: "Track and Manage Requests", description: "Use our app to see who's coming, check job status, and communicate directly with your helper. Everything is managed in one convenient place." },
  { title: "Support Your Community", description: "By using Shovel House, you're helping to create jobs and support local individuals looking to earn extra income." },
  { title: "Trusted and Secure Platform", description: "Your information and payments are safe with us. We use industry-standard security practices to ensure your data is protected." },
]

export function LearnMore() {
  const navigate = useNavigate()

  return (
    <main className="flex flex-col min-h-screen bg-background text-foreground">
      {/* Header */}
      <header className="flex items-center justify-between px-4 py-3">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-sm font-medium hover:underline"
        >
          <ArrowLeft className="w-4 h-4" /> Back
        </button>

        <button
          onClick={() => navigate("/")}
          aria-label="home"
          className="p-2 rounded-md hover:opacity-80"
        >
          <Home className="w-5 h-5" />
        </button>
      </header>

      {/* Content */}
      <section className="flex-1 px-4 py-8 max-w-4xl mx-auto w-full">
        <h1 className="text-2xl font-bold mb-6 text-center">Learn More</h1>

        <div className="grid gap-">
          {featuresList.map((feature, index) => (
            <Card
              key={index}
              className="bg-card/60 shadow-sm border-transparent" /* keep Card but remove harsh borders */
            >
              <CardContent className="px-5">
                <h2 className="font-semibold text-lg">{feature.title}</h2>
                <p className="text-sm text-muted-foreground mt-1 leading-relaxed">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>

      {/* CTA (Join Us restored) */}
      <footer className="px-4 py-6 border-t">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center gap-4">
          {/* Join Us (restored exactly as a block, styled nicely) */}
          <div className="sm:w-1/3 text-center sm:text-left text-sm font-medium">
            <span className="block">Join Us</span>
            <span className="block text-xs text-muted-foreground">Choose your role to get started</span>
          </div>

          {/* Buttons — BOTH use bg-secondary and hover:bg-gray-800 */}
          <div className="flex-1 flex gap-3 w-full">
            <Button
              className="flex-1 bg-secondary text-white hover:bg-gray-800"
              onClick={() => navigate("/prelaunch")}
            >
              Homeowner
            </Button>

            <Button
              className="flex-1 bg-secondary text-white hover:bg-gray-800"
              onClick={() => navigate("/shovellerSignupProcess")}
            >
              Neighbourhood Helper
            </Button>
          </div>
        </div>
      </footer>
    </main>
  )
}
